import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {
  addSalary,
  deleteSalarys,
  getSalarys,
  getSalarysById,
  updateSalaryById,
} from '../../../api/SalaryAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'

export const getSalary = (setSalary: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getSalarys().then((res: any) => {
    if (res.statusCode === 200) {
      const salarysWithIndex = res.data.map((salary: any, index: number) => ({
        ...salary,
        index: index + 1,
      }))
      setSalary(salarysWithIndex)
      setSalary(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

export const handleSubmit = (
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  getSalary: Function,
  setSalary: Function,
  setEditId: Function,
  initialState: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  validateForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function
) => {
  // Validate the form fields
  let {cnt, error} = validateForm(InputField)
  setInputError(error)

  if (cnt === 0) {
    // Perform operations for adding or updating salary based on editId
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
      // Multiply salary structure values by 12 if salaryType is 'monthly'
      const adjustedValues =
        InputField.salaryType === 'monthly'
          ? Object.keys(InputField.salaryStructureValues).reduce((acc, key) => {
              const value = InputField.salaryStructureValues[key]
              acc[key] = typeof value === 'number' ? value * 12 : value
              return acc
            }, {})
          : InputField.salaryStructureValues

      // Add new salary entry with adjustedValues
      addSalary({...InputField, salaryStructureValues: adjustedValues}).then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message)
          getSalary(setSalary, setAPIStatus)
          cancelSubmit(setInputField, initialState, setEditId, setInputError)
          setIsAddUserModalOpen(false)
        } else {
          Message(res.message, 'error')
        }
        setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
      })
    } else {
      // Update existing salary entry
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({...prev, loading: true}))
          // Multiply salary structure values by 12 if salaryType is 'monthly'
          const adjustedValues =
            InputField.salaryType === 'monthly'
              ? Object.keys(InputField.salaryStructureValues).reduce((acc, key) => {
                  const value = InputField.salaryStructureValues[key]
                  acc[key] = typeof value === 'number' ? value * 12 : value
                  return acc
                }, {})
              : InputField.salaryStructureValues

          // Update salary entry with adjustedValues
          updateSalaryById({...InputField, salaryStructureValues: adjustedValues}, editId).then(
            (res: any) => {
              if (res.statusCode === 200) {
                getSalary(setSalary, setAPIStatus)
                toast.success(res.message)
                cancelSubmit(setInputField, initialState, setEditId, setInputError)
                setEditId(null)
                setIsAddUserModalOpen(false)
              } else {
                Message(res.message, 'error')
              }
              setSubmitAPIStatus((prev: any) => ({...prev, loading: false}))
            }
          )
        }
      })
    }
  }
}

export const deleteSalary = (
  id: string,
  getSalary: Function,
  setSalary: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  setEditId: Function,
  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)

  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteSalarys(id)
        .then((res: any) => {
          if (res.statusCode === 202 || res.statusCode === 200) {
            getSalary(setSalary, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((err: any) => {
          Message(err.message, 'error')
        })
    }
  })
}

export const handleInputChange = (
  event: React.SyntheticEvent,
  setInputField: Function,
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  }
) => {
  let target = event.target as HTMLInputElement
  const {name, value, type, checked} = target
  const newValue = type === 'checkbox' ? checked : value

  if (InputField.salaryStructureValues.hasOwnProperty(name)) {
    setInputField({
      ...InputField,
      salaryStructureValues: {
        ...InputField.salaryStructureValues,
        [name]: newValue,
      },
    })
  } else {
    setInputField({
      ...InputField,
      [name]: newValue,
    })
  }
}

export const getSalaryById = (
  id: string,
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getSalarysById(id).then((res: any) => {
    if (res && res.data) {
      const {date, annualPackage, user, band, salaryType, salaryStructure, salaryStructureValues} =
        res.data


      const salaryStructureValuesArray = Array.isArray(salaryStructureValues)
        ? salaryStructureValues
        : []

      setInputField({
        ...InputField,
        date: date || '',
        annualPackage: annualPackage || '',
        user: user ? user.id : '',
        band: band ? band.id : '',
        salaryType: salaryType || '',
        salaryStructure: salaryStructure ? salaryStructure.id : '',
        salaryStructureValues: {
          basic: salaryStructureValuesArray[0]?.basicValue || '',
          HRA: salaryStructureValuesArray[0]?.HRAValue || '',
          education: salaryStructureValuesArray[0]?.educationValue || '',
          DA: salaryStructureValuesArray[0]?.DAValue || '',
          LTA: salaryStructureValuesArray[0]?.LTAValue || '',
          specialAllowance: salaryStructureValuesArray[0]?.specialAllowanceValue || '',
          variable: salaryStructureValuesArray[0]?.variableValue || '',
          telephoneAndInternetReimbursement:
            salaryStructureValuesArray[0]?.telephoneAndInternetReimbursementValue || '',
          carAndDriverReimbursement:
            salaryStructureValuesArray[0]?.carAndDriverReimbursementValue || '',
          mealCoupon: salaryStructureValuesArray[0]?.mealCouponValue || '',
          booksAndPeriodicals: salaryStructureValuesArray[0]?.booksAndPeriodicalsValue || '',
          PF: salaryStructureValuesArray[0]?.PFValue || '',
          PT: salaryStructureValuesArray[0]?.PTValue || '',
          ESIC: salaryStructureValuesArray[0]?.ESICValue || '',
          LWF: salaryStructureValuesArray[0]?.LWFValue || '',
        },
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error')
    }
  })
}

export const getSalaryByEyeId = (
  id: string,
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
    salaryStructureValues: any
  },
  setInputField: Function,
  setInputError: Function
) => {
  getSalarysById(id).then((res: any) => {
    if (res && res.data) {
      const {date, annualPackage, user, band, salaryType, salaryStructure, salaryStructureValues} =
        res.data


      setInputField({
        ...InputField,
        date: date || '',
        annualPackage: annualPackage || '',
        user: user ? user.id : '',
        band: band ? band.id : '',
        salaryType: salaryType || '',
        salaryStructure: salaryStructure ? salaryStructure.id : '',
        salaryStructureValues: {
          basic: salaryStructureValues[0]?.basicValue || '',
          HRA: salaryStructureValues[0]?.HRAValue || '',
          education: salaryStructureValues[0]?.educationValue || '',
          DA: salaryStructureValues[0]?.DAValue || '',
          LTA: salaryStructureValues[0]?.LTAValue || '',
          specialAllowance: salaryStructureValues[0]?.specialAllowanceValue || '',
          variable: salaryStructureValues[0]?.variableValue || '',
          telephoneAndInternetReimbursement:
            salaryStructureValues[0]?.telephoneAndInternetReimbursementValue || '',
          carAndDriverReimbursement: salaryStructureValues[0]?.carAndDriverReimbursementValue || '',
          mealCoupon: salaryStructureValues[0]?.mealCouponValue || '',
          booksAndPeriodicals: salaryStructureValues[0]?.booksAndPeriodicalsValue || '',
          PF: salaryStructureValues[0]?.PFValue || '',
          PT: salaryStructureValues[0]?.PTValue || '',
          ESIC: salaryStructureValues[0]?.ESICValue || '',
          LWF: salaryStructureValues[0]?.LWFValue || '',
        },
      })
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error')
    }
  })
}

export const validateForm = (InputField: {
  annualPackage: string
  date: string
  user: string
  salaryStructure: string
  band: {minCtc: number; maxCtc: number}
}) => {
  let cnt = 0
  const error: any = {}

  const minSalaryLength = 1
  const maxSalaryLength = 10

  const trimmedSalary = InputField.annualPackage.trim()
  const annualPackage = parseFloat(trimmedSalary)

  if (!trimmedSalary) {
    cnt++
    error.annualPackage = 'Please enter an Annual Package.'
  } else if (isNaN(annualPackage)) {
    cnt++
    error.annualPackage = 'Annual Package must be a valid number.'
  } else if (annualPackage < InputField.band.minCtc || annualPackage > InputField.band.maxCtc) {
    cnt++
    error.annualPackage = `Annual Package must be between ${InputField.band.minCtc} and ${InputField.band.maxCtc}.`
  } else if (trimmedSalary.length < minSalaryLength) {
    cnt++
    error.annualPackage = 'Annual Package must contain at least 1 digit.'
  } else if (trimmedSalary.length > maxSalaryLength) {
    cnt++
    error.annualPackage = 'Annual Package must not exceed 10 digits.'
  }

  if (!InputField.date.trim()) {
    cnt++
    error.date = 'Please select/enter a valid Date.'
  }

  if (!InputField.user.trim()) {
    cnt++
    error.user = 'Please select a User.'
  }

  if (!InputField.salaryStructure.trim()) {
    cnt++
    error.salaryStructure = 'Please select a Salary Structure.'
  }

  return {error, cnt}
}

export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    date: string
    user: string
    band: string
    salaryType: string
    salaryStructure: string
    annualPackage: string
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
